import { render, staticRenderFns } from "./BoxActivate.vue?vue&type=template&id=572256a9"
import script from "./BoxActivate.vue?vue&type=script&lang=js"
export * from "./BoxActivate.vue?vue&type=script&lang=js"
import style0 from "./BoxActivate.vue?vue&type=style&index=0&id=572256a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports